define('modules/domain_listing/views/domain_help_popup',['require','exports','module','common/views/modal_view','backbone','ldsh!../templates/domain_help_popup'],function(require, exports, module) {
  "use strict";

  var ModalView = require("common/views/modal_view"),
      Backbone = require("backbone");

  module.exports = ModalView.extend({
    template: require("ldsh!../templates/domain_help_popup"),
    remove: function() {
      Backbone.history.navigate("/domains", {trigger:true});
      //NASTY!!!!!
      module.exports.__super__.remove.apply(this, arguments);
    },
    onRender: function() {
      this.$el.i18n();
    }
  },{
    show: function() {
      return new module.exports();
    }
  });

});

